import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form, InputGroup, FormControl } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import api from '../helper/api';
import { getServerURL } from '../helper/envConfig';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';
import Loader from './Loader/Loader';
import formatDate from '../helper/dateFormat';
import PaginationC from './pagination';


const Category = (props) => {

    const serverURL = getServerURL()

    const [modalShow, setModalShow] = useState(false);

    const modalOpen = () => {
        setModalShow(true)
        getMainCategory();
    }

    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [states, setStates] = useState({})

    const [validated, setValidated] = useState(false);
    const [mainCategoryData, setMainCategoryData] = useState([])
    const [subCategoryData, setSubCategoryData] = useState([])
    const [deleteData, setDeleteData] = useState()
    const [loading, setLoading] = useState(true)
    const [subLoader, setSubLoader] = useState(false)
    const [mode, setMode] = useState()
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    useEffect(() => {
        getSubCategory();
    }, [searchText, page]);

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    const getSubCategory = () => {
        api.getWithToken(`${serverURL}product/category/?page=${page}${searchText && `&_i=${searchText}`}`)
            .then(async (res) => {
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                setLoading(false)
                if (res?.data?.success === true) {
                    setSubCategoryData(data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const getMainCategory = (event) => {
        api.getWithToken(`${serverURL}product/category/?_m=`)
            .then(async (res) => {
                if (res?.data?.success === true) {
                    setMainCategoryData(res?.data?.data);
                }
            })
            .catch((e) => {
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStates((prevValues) => ({
            ...prevValues,
            [name]: value.trimStart(),
        }));
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        setSubLoader(true)
        event.preventDefault();
        if (form.checkValidity()) {
            setValidated(false);
            const type = Boolean(mode) ? "postWithToken" : "putWithToken";
            const formData = {
                "slug": states?.slug,
                "name": states?.name,
                "category": states?.category_slug || null
            }

            api[type](`${serverURL}product/category/`, Boolean(mode) ? states : formData)
                .then(async (res) => {
                    setModalShow(false)
                    setStates({})
                    form.reset();
                    setLoading(false);
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getSubCategory();
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setSubLoader(false)
                    errorResponse(e);
                });
        } else {
            setValidated(true);
            setSubLoader(false)
            event.stopPropagation();
        }
    };

    const deleteCategory = () => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}product/category/${deleteData?.slug}`)
            .then(async (res) => {
                setSubLoader(false)
                setDeleteModalShow(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getSubCategory()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
            })
            .catch((e) => {
                setSubLoader(false)
                errorResponse(e);
            });
    };

    return (
        <>

            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                                <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); modalOpen() }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Name</th>
                                <th>Category</th>
                                <th>Created At</th>
                                <th>Updated At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(subCategoryData?.length) ? subCategoryData?.map((item, index) =>
                                    <tr key={index + "category"}>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <h6 className="m-0">{item?.name || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.category || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{formatDate(new Date(item?.created_at)) || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{formatDate(new Date(item?.updated_at)) || "-"}</h6>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                {/* <div className='cursor-pointer' onClick={() => setViewModalShow(true)}>
                                                <i className="feather icon-eye" title='View' />
                                            </div> */}
                                                <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); modalOpen() }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                <div className='cursor-pointer' onClick={() => { setDeleteData({ slug: item?.slug }); setDeleteModalShow(true) }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={6} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(subCategoryData?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}

            {/* add & edit modal */}
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}

                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" required placeholder="Enter name here" value={states?.name || ""} name='name' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter category name.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Category
                                    </Form.Label>
                                    <Col sm={9}>
                                        <InputGroup className="mb-3">
                                            <FormControl as="select" aria-describedby="custom-addons1" className="custom-select" value={states?.category_slug || states?.category || ""} name='category' onChange={handleChange}>
                                                <option value={""} disabled>Choose main category</option>
                                                {Boolean(mainCategoryData?.length) &&
                                                    mainCategoryData?.map((item, index) => <option value={item?.slug} className='text-capitalize'>{item?.name}</option>)}
                                            </FormControl>
                                        </InputGroup>
                                    </Col>
                                </Form.Group>

                                <div className='d-flex justify-content-end'>
                                    <Button type="submit" className='m-0'>{Boolean(mode) ? "Save" : "Update"}</Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

            {/* Delete */}
            <Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deleteCategory()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Category